<template style="background-color:white">
  <section>
    <DC :transferValue="transferValue"></DC>
  </section>
</template>
<!-- 调换设备 -->
<script>
import {
  updateStatus
} from "../../../api/api";
import MultipleDevices from "../../../components/common/MultipleDevices.vue";
export default {
  name: "ReceiptExchange",
  components: {
    DC: MultipleDevices
  },
  data() {
    return {

    }
  },
  props: {
    exchangeForm: { type: Object }
  },
  created() {

  },
  methods: {

  }
}
</script>



// WEBPACK FOOTER //
// src/views/market/components/ReceiptExchange.vue